import script from "./ScoreRangeFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScoreRangeFilter.vue?vue&type=script&setup=true&lang=ts"

import "./ScoreRangeFilter.vue?vue&type=style&index=0&id=5cc24c80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cc24c80"]])

export default __exports__